var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "element-library-selector-wrapper" },
    [
      _setup.library || _vm.mixedLibrary
        ? _c(
            "section",
            { staticClass: "library-details" },
            [
              _c(
                "div",
                { staticClass: "header-container" },
                [
                  _vm._t("header"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "title rounded d-flex align-items-center align-self-end",
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: ["far", "book"] },
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.mixedLibrary ? "Mixed" : _setup.library?.name
                          ) +
                          "\n                "
                      ),
                      _c(_setup.CButton, {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.readonly,
                            expression: "!readonly",
                          },
                        ],
                        staticClass: "ml-auto",
                        attrs: {
                          icon: ["far", "xmark"],
                          size: "icon",
                          disabled: _vm.disabled,
                        },
                        on: { click: _setup.onRemoveLibrary },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              !_setup.library && _vm.mixedLibrary
                ? _c(_setup.CInput, {
                    attrs: {
                      value: _vm.selectedPosition,
                      label: "Option",
                      type: "number",
                      min: 0,
                      placeholder: "Mixed",
                    },
                    on: { input: _setup.changeOption },
                  })
                : _setup.library
                ? [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _setup.libraryCategories.length
                          ? _c(_setup.CSelect, {
                              staticClass: "col-6 pr-0",
                              attrs: {
                                label: "Category",
                                searchable: "",
                                options: _setup.libraryCategories,
                                disabled: _setup.searchString.length > 0,
                              },
                              on: { input: _setup.onCategorySelected },
                              model: {
                                value: _setup.selectedLibCategory,
                                callback: function ($$v) {
                                  _setup.selectedLibCategory = $$v
                                },
                                expression: "selectedLibCategory",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(_setup.CInput, {
                          staticClass: "col-6 search-box",
                          class: { "col-12": !_setup.libraryCategories.length },
                          attrs: {
                            placeholder: "Search",
                            type: _setup.searchByName ? "search" : "number",
                          },
                          on: { debounce: _setup.onElementSearch },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c(_setup.CSelect, {
                                      staticClass: "type-selector",
                                      attrs: {
                                        options: _setup.libSearchOptions,
                                        "model-transform": _setup.valueReducer,
                                      },
                                      on: { input: _setup.resetSearch },
                                      model: {
                                        value: _setup.searchByName,
                                        callback: function ($$v) {
                                          _setup.searchByName = $$v
                                        },
                                        expression: "searchByName",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2715994833
                          ),
                          model: {
                            value: _setup.searchString,
                            callback: function ($$v) {
                              _setup.searchString = $$v
                            },
                            expression: "searchString",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(_setup.DraggableList, {
                      attrs: {
                        "item-key": "position",
                        draggable: false,
                        selected: _vm.selectedPosition,
                      },
                      on: { "row-click": _setup.onLibraryElementSelected },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item",
                            fn: function ({ element }) {
                              return [
                                _setup.params.isColorLib
                                  ? _c("span", {
                                      staticClass: "color-preview",
                                      style: _setup.getColorElement(element),
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _setup.params.isImageLib ||
                                _setup.params.isVectorLib
                                  ? _c(_setup.CPreview, {
                                      staticClass: "mx-2",
                                      attrs: {
                                        src: element.thumbnailPath,
                                        width: 30,
                                        "max-height": "30px",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    style: {
                                      fontFamily: `'${_setup.generateSafeFontName(
                                        element.name
                                      )}', Arial`,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(element.name || element.hex) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "option-label" }, [
                                  _vm._v(
                                    " Option ID: " +
                                      _vm._s(element.position) +
                                      " "
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3988710241
                      ),
                      model: {
                        value: _setup.library.elements,
                        callback: function ($$v) {
                          _vm.$set(_setup.library, "elements", $$v)
                        },
                        expression: "library.elements",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : [
            _vm._t("header"),
            _vm._v(" "),
            _setup.displayOptionMapList && !_vm.mixedElementList
              ? _c(_setup.DraggableList, {
                  attrs: {
                    "item-key": "id",
                    selected: _vm.selectedPosition,
                    draggable:
                      !_vm.disabled && !_vm.readonly && !_vm.readonlyOptions,
                  },
                  on: {
                    "row-click": (option) => _setup.changeOption(option.id),
                    "drag-end": _setup.onOptionDragEnd,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item",
                        fn: function ({ element, selected, index }) {
                          return [
                            _setup.params.isColorLib
                              ? _c("span", {
                                  staticClass: "color-preview",
                                  style: _setup.getColorElement(element),
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _setup.openElementSelection(
                                        element.id
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _setup.openElementSelection(
                                      element.id
                                    )
                                  },
                                },
                              },
                              [
                                _setup.params.isImageLib ||
                                _setup.params.isVectorLib
                                  ? _c(_setup.CPreview, {
                                      staticClass: "mx-2",
                                      attrs: {
                                        src: _setup.getElementPreview(
                                          element.value
                                        ),
                                        width: 30,
                                        "max-height": "30px",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            element.name.length
                              ? _c(
                                  "span",
                                  {
                                    style: {
                                      fontFamily: `'${_setup.generateSafeFontName(
                                        element.name
                                      )}', Arial`,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(element.name) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.readonly && !_vm.readonlyOptions
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "actions ml-auto",
                                    class: { visible: selected },
                                  },
                                  [
                                    _c(_setup.CButton, {
                                      attrs: {
                                        icon: [
                                          "far",
                                          _setup.params.editIcon || "pen",
                                        ],
                                        size: "icon",
                                        disabled: _vm.disabled,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _setup.openElementSelection(
                                            element.id
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _setup.optionsMap.length > 1
                                      ? _c(_setup.CButton, {
                                          attrs: {
                                            icon: ["far", "trash-can"],
                                            size: "icon",
                                            disabled: _vm.disabled,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _setup.onMapOptionRemoved(
                                                element.id,
                                                index
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1516288025
                  ),
                  model: {
                    value: _setup.optionsMap,
                    callback: function ($$v) {
                      _setup.optionsMap = $$v
                    },
                    expression: "optionsMap",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            (_setup.params.isImageLib || _setup.params.isVectorLib) &&
            !_vm.externalImagePicker
              ? _c(_setup.CFileInput, {
                  ref: "fileInputRef",
                  staticClass: "d-none",
                  attrs: {
                    value: [],
                    accept: _setup.params.fileTypes,
                    multiple: "",
                    "display-preview": false,
                  },
                  on: {
                    input: _setup.onFileUpload,
                    cancel: _setup.closeSelection,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _setup.displayFontSelector
              ? _c(_setup.FontSelector, {
                  ref: "pickerRef",
                  attrs: {
                    open: _setup.selectionMode.open,
                    disabled: _vm.disabled,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.onElementSelected()
                    },
                  },
                  model: {
                    value: _setup.selectedFont,
                    callback: function ($$v) {
                      _setup.selectedFont = $$v
                    },
                    expression: "selectedFont",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _setup.params.isColorLib
              ? _c(_setup.ColorSelector, {
                  ref: "pickerRef",
                  attrs: {
                    open:
                      _setup.selectionMode.open && _setup.clickOutsideActive,
                    "is-cmyk": _vm.cmyk,
                    color: _setup.colorElementToEdit,
                    "enable-palette": _vm.enablePalette,
                    "show-menu-types": _vm.showMenuTypes,
                  },
                  on: {
                    cancel: _setup.closeSelection,
                    "color-selected": _setup.onElementSelected,
                    "color-changed": function ($event) {
                      return _setup.emit("preview-selection", $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions-container" },
              [
                _vm._t("actions"),
                _vm._v(" "),
                _vm.mixedElementList
                  ? _c(_setup.CInput, {
                      attrs: {
                        value: _vm.selectedPosition,
                        label: "Option",
                        type: "number",
                        min: 1,
                        placeholder: "Mixed",
                      },
                      on: { input: _setup.changeOption },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.readonly && !_vm.mixedElementList
                  ? [
                      !_vm.readonlyOptions
                        ? _c(_setup.CButton, {
                            class: {
                              "flex-fill": !_vm.hideLibrarySelection,
                              "px-5": _vm.hideLibrarySelection,
                            },
                            attrs: {
                              variant: "secondary",
                              text: `Add ${_setup.params.wording} option`,
                              icon: ["far", "plus"],
                              disabled: _vm.disabled,
                            },
                            on: {
                              click: function ($event) {
                                return _setup.openElementSelection()
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(
                        _vm.hideLibrarySelection
                          ? []
                          : _setup.libraryPickOptions,
                        function (option, index) {
                          return _c(_setup.CButton, {
                            key: index,
                            staticClass: "flex-fill",
                            attrs: {
                              variant: "light",
                              text: option.text,
                              icon: ["far", "book"],
                              disabled: _vm.disabled,
                            },
                            on: {
                              click: function ($event) {
                                return _setup.emit("pick-library", option.type)
                              },
                            },
                          })
                        }
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.mixedElementList
              ? [
                  _c(
                    "div",
                    { staticClass: "mixed-elements-row" },
                    [
                      _c("span", [
                        _vm._v("Mixed " + _vm._s(_setup.params.wording) + "s"),
                      ]),
                      _vm._v(" "),
                      _c(_setup.CButton, {
                        staticClass: "py-0",
                        attrs: { text: "Replace", variant: "link", size: "sm" },
                        on: {
                          click: function ($event) {
                            return _setup.openElementSelection()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }